export enum EmailTemplateStatus {
	Published = 'published',
	Draft = 'draft'
}
